@if (vm$ | async; as vm) {
    @if (vm.isLinearBetslip) {
        <bs-linear-summary-errors />
    } @else {
        <bs-summary-errors />
    }

    @if (!vm.isLinearBetslip && !isQuickDepositOpen) {
        <div
            class="betslip-summary-row betslip-summary-row--grid betslip-summary-row--stake"
            [class.epcot-betslip-stakebar]="!isNumpadOpenWhenEpcotEnabled">
            <span class="betslip-summary__stake">{{ messages.stake }}</span>
            <div class="betslip-summary__stake-per-bet">
                <div>{{ messages.stakePerBet }}</div>
                <div class="betslip-summary__bets-count">{{ vm.userBetCount > 0 ? vm.userBetCount : '--' }} {{ messages.bets }}</div>
            </div>
            <bs-digital-summary-stake [stake]="vm.stake" [keypadId]="keypadId" (stakeChange)="onStakeChanged($event)" />
            @if (betslipConfig.isLinearKeypadEnabled) {
                <bs-linear-stake-keyboard />
            } @else {
                <bs-digital-summary-stake-keyboard />
            }
            @if (vm.tokenContext) {
                <bs-reward-tokens-selector-container [tokenContext]="vm.tokenContext" />
            }
            @if (vm.showTokenSummaryInStakeRow) {
                <bs-digital-token-summary-container [tokenContext]="vm.summaryTokenContext!" />
            }
        </div>
    }
    @if (vm.isLinearBetslip && !isQuickDepositOpen) {
        <div [class.epcot-betslip-stakebar]="!isNumpadOpenWhenEpcotEnabled">
            <bs-linear-stake-keyboard />
        </div>
    }
    @if (isQuickDepositOpen) {
        <div title="{{ messages.stake }}" class="betslip-summary-row betslip-summary__quick-deposit-stake betslip-summary-row--grid">
            <span>{{ messages.stake }}</span>
            <span class="betslip-summary-value">{{ vm.stake | bsCurrency: true }}</span>
        </div>
    }
    <div class="betslip-summary-row betslip-summary__total-stake">
        <span>{{ messages.totalStake }}</span>
        <span class="betslip-summary-value">{{ vm.totalStake | bsCurrency: true }}</span>
    </div>
    @if (!hideTotalOdds) {
        <div class="betslip-summary-row betslip-summary__total-odds">
            <span class="caption">{{ messages.totalOdds }}</span>
            <span class="betslip-summary-value">
                <span
                    class="betslip-summary__original-odds"
                    [ngClass]="{ 'betslip-summary__original-odds--boosted': vm.boostedOdds }"
                    [@oldOddsAnimation]="vm.boostedOdds ? formattedOdds(vm.totalOdds) : null"
                    >{{ formattedOdds(vm.totalOdds) }}</span
                >
                @if (vm.boostedOdds) {
                    <span class="betslip-summary__boosted-odds" [@newOddsAnimation]="formattedOdds(vm.boostedOdds)">{{
                        formattedOdds(vm.boostedOdds)
                    }}</span>
                }
            </span>
        </div>
    }
    <div class="betslip-summary-row betslip-summary-row--grid betslip-summary-row--winnings">
        <span class="betslip-summary__possible-winnings">
            {{ vm.isLinearBetslip ? messages.totalReturns : messages.possibleWinnings }}
            @if (isTurnOverTax) {
                <a class="theme-info betslip-summary__possible-winnings--info" (click)="displayTaxationInfo()"></a>
            }
        </span>
        <span class="betslip-summary__possible-winnings-net" (click)="displayTaxationInfo()">
            {{ vm.isLinearBetslip ? messages.totalReturnsNet : messages.possibleWinningsNet }}
            <a class="theme-info betslip-summary__possible-winnings-net--info"></a>
        </span>
        @if (!isTurnOverTax && !vm.isPotentailReturn) {
            <span class="betslip-summary-value betslip-summary__possible-winnings">
                @if (vm.originalWinnings) {
                    <span class="betslip-summary__possible-winnings--original">
                        {{ vm.possibleWinnings ? (vm.originalWinnings | bsCurrency: true) : null }}
                    </span>
                }
                {{ vm.possibleWinningsNet ?? vm.possibleWinnings | bsCurrency: true }}
            </span>
            <span class="betslip-summary-value betslip-summary__possible-winnings-net">{{ vm.possibleWinningsNet | bsCurrency: true }}</span>
        }
        @if (isTurnOverTax) {
            <span class="betslip-summary-value betslip-summary__possible-winnings">
                @if (vm.originalWinnings) {
                    <span class="betslip-summary__possible-winnings--original">
                        {{ (vm.possibleWinnings ? vm.possibleWinnings : possibleWinningsValue) | bsCurrency: true }}
                    </span>
                }
                {{ (vm.possibleWinningsNet ? vm.possibleWinnings : possibleWinningsValue) | bsCurrency: true }}
            </span>
            <span class="betslip-summary-value betslip-summary__possible-winnings-net">{{
                (vm.possibleWinningsNet ? vm.possibleWinningsNet : possibleWinningsValue) | bsCurrency: true
            }}</span>
        }
        @if (vm.isPotentailReturn) {
            <span class="betslip-summary-value betslip-summary__possible-winnings"> {{ sitecore.common.NA }} </span>
        }
    </div>
    @if (isTurnOverTax) {
        <div class="betslip-summary__tax-info">
            <span class="betslip-summary__tax-info-message">{{ vm.taxationVM?.taxationMessage }}</span>
        </div>
    }
    @if (vm.showTokenSummary) {
        <bs-digital-token-summary-container [tokenContext]="vm.summaryTokenContext!" />
    }
    @if (isTaxationInfoVisible && vm.taxationVM) {
        <bs-digital-taxation-info [vm]="vm.taxationVM" [(isVisible)]="isTaxationInfoVisible" />
    }
    @if (isStakeLimitsInfoDisplayed) {
        <bs-user-stake-limits />
    }
}
<bs-quick-deposit-message />
